import React, { PropsWithChildren } from 'react';
import { Box, Theme, useTheme } from '@mui/material';

import { VpBorderRadius } from '../../features/variety-planner/styles';

const makeStyles = (theme: Theme) => ({
  customCard: {
    borderRadius: VpBorderRadius.MEDIUM,
    backgroundColor: theme.palette.questionsForm.cardBg,
    padding: theme.spacing(1, 2.75),
    width: '100%',
  },
});

const AppCard: React.FC<Readonly<PropsWithChildren>> = ({ children }) => {
  const theme = useTheme();
  const styles = makeStyles(theme);

  return <Box sx={styles.customCard}>{children}</Box>;
};

export default AppCard;
